import React from "react";
import { useTranslation } from "react-i18next";
import ConfirmDialog from "../feedback/ConfirmDialog";

const ConfirmDelete = ({
  show,
  onHide,
  confirmDescription,
  confirmButtonText,
  onConfirmClick,
}) => {
  const { t } = useTranslation();

  return (
    <ConfirmDialog
      show={show}
      onHide={onHide}
      description={t(confirmDescription || "message.confirm.confirmDeleteImage")}
      confirmText={t(confirmButtonText || "message.confirm.deleteImage")}
      onConfirm={onConfirmClick}
    />
  );
};

export default ConfirmDelete;
